// Opens a clean printable sheet in a new window (no fabricated downloadable files).
export function printSheet(title, desc, code = "en") {
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;
  const lines = Array.from({ length: 10 }).map(() => '<div style="border-bottom:1.5px solid #cbd5e1;height:34px;"></div>').join("");
  w.document.write(`<!doctype html><html lang="${code === "zh" ? "zh-CN" : "en"}"><head><meta charset="utf-8"><title>${title} · LUMORA</title>
  <style>
    body{font-family:'Nunito','Noto Sans SC',sans-serif;color:#082B66;padding:48px;max-width:720px;margin:0 auto;}
    h1{font-size:28px;margin:0 0 6px;}
    p{color:#475569;font-size:15px;}
    .brand{display:flex;align-items:center;gap:10px;margin-bottom:24px;}
    .brand span{font-weight:800;font-size:20px;}
    .box{margin-top:24px;}
    @media print{button{display:none;}}
    button{margin-top:24px;padding:10px 18px;border:0;border-radius:10px;background:#147DEB;color:#fff;font-weight:700;cursor:pointer;}
  </style></head><body>
  <div class="brand"><span>✦ LUMORA</span></div>
  <h1>${title}</h1><p>${desc}</p>
  <div class="box">${lines}</div>
  <p style="margin-top:28px;color:#94a3b8;font-size:12px;">LUMORA — A Brighter Future Starts With Education</p>
  <button onclick="window.print()">${code === "zh" ? "打印" : "Print"}</button>
  </body></html>`);
  w.document.close();
}
